import { CellAlign, HeadCell } from '@dfl/mui-admin-layout';
import { IOrder } from 'modules/sales/common/interfaces/IOrder';
import { SUB_ORDER_ROUTE } from './sub-order.route';
import { OrderCodeCell } from 'modules/sales/common/components/OrderCodeCell';
import { ORDER_PERMISSIONS } from 'modules/sales/common/constants/order-permissions';
import { ReactLink } from '@dfl/react-security';
import { DISTRIBUTION_CENTER_PERMISSIONS } from 'modules/inventory/distribution-centers/constants';

export const subOrderCodeColumn = (header?: string, width?: number): HeadCell<IOrder> => ({
  field: 'code',
  headerName: header || 'order:code',
  disablePadding: true,
  width,
  renderCell: (code: string, data: IOrder) => (
    <OrderCodeCell value={code} link={SUB_ORDER_ROUTE.DETAIL(data?._id as string)} record={data} isSubOrder />
  ),
  permissions: [ORDER_PERMISSIONS.ORDER_VIEW],
});

export const subOrderDistributionCenterColumn: HeadCell<IOrder> = {
  field: 'distributionCenter',
  headerName: 'distributionCenters:name',
  disablePadding: true,
  align: CellAlign.CENTER,
  permissions: [ORDER_PERMISSIONS.ORDER_VIEW],
  renderCell: (value: { _id: string; name: string }) => (
    <ReactLink
      permissions={DISTRIBUTION_CENTER_PERMISSIONS.DISTRIBUTION_CENTER_VIEW}
      to={`/inventory/distribution-centers/${value?._id}/general`}
    >
      {value?.name}
    </ReactLink>
  ),
};
